export default "/static/dashboard/build/app/img/v2/2334da47d68584b32a16b69ad1a28094.png";